module.exports = __webpack_public_path__ + "static/img/IMG_1809_02.4ec65c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/IMG_1809_02.png
// module id = FoiD
// module chunks = 1